<template>
    <button class="flex justify-center items-center rounded-md" :class="[{
        'h-[30px] px-3.5': size === 'small',
        'h-[33px] px-5': size === 'medium',
        'h-[40px] px-[18px]': size === 'large',
        'border': type === 'primary' || type === 'secondary',
        'text-white': type === 'primary' && colour !== 'white',
    }, backgroundClass, borderClass]">
        <i v-if="icon" class="fal mr-2" :class="'fa-'+icon"></i>
        <slot />
    </button>
</template>

<style scoped>

</style>

<script setup lang="ts">

    const props = defineProps({
        type: {
            type: String as PropType<'primary' | 'secondary' | 'tertiary'>,
            required: true,
        },
        size: {
            type: String,
            required: true,
        },
        icon: {
            type: String,
            required: false
        },
        colour: {
            type: String as PropType<'blue' | 'green' | 'orange' | 'red' | 'grey' | 'white'>,
            default: 'blue',
        }
    });

    const backgroundClass = computed(() => {
        if(props.type === 'secondary') {
            return 'bg-white'
        }
        if(props.type === 'tertiary') {
            return '';
        }
        switch(props.colour) {
            case 'blue':
                return 'bg-sn-blue';
            case 'green':
                return 'bg-sn-green';
            case 'orange':
                return 'bg-sn-orange';
            case 'red':
                return 'bg-sn-dark-red';
            case 'grey':
                return 'bg-sn-grey';
            case 'white':
                return 'bg-white';
        }
    })

    const borderClass = computed(() => {
        if(props.type === 'secondary') {
            switch(props.colour) {
                case 'blue':
                    return 'border-sn-blue';
                case 'green':
                    return 'border-sn-green';
                case 'orange':
                    return 'border-sn-orange';
                case 'red':
                    return 'border-sn-dark-red';
                case 'grey':
                    return 'border-sn-grey';
            }
        }
        if(props.type === 'tertiary') {
            return '';
        }
        switch(props.colour) {
            case 'blue':
                return 'border-sn-dark-blue';
            case 'orange':
                return 'border-sn-orange-dark';
            case 'red':
                return 'border-sn-darker-red';
            case 'grey':
                return 'border-sn-grey';
            case 'white':
                return 'border-white';
        }
    })
</script>